// Desktop-only rail enhancements: arrow buttons scroll one card width; pointer drag
// scrolls the rail and suppresses the click a drag would otherwise trigger on a
// product link. Mobile keeps native touch scrolling.
class ScentivaRail {
  constructor(rail) {
    this.rail = rail;
    this.track = rail.querySelector('.scentiva-collection-rail__track');
    if (!this.track) return;
    this.dragging = false;
    this.moved = false;
    rail.addEventListener('click', this.onClickCapture.bind(this), true);
    this.track.addEventListener('pointerdown', this.onPointerDown.bind(this));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.track.style.scrollBehavior = 'smooth';
    }
  }

  cardStep() {
    const item = this.track.querySelector('.grid__item');
    if (!item) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  onClickCapture(event) {
    if (this.moved) {
      event.preventDefault();
      event.stopPropagation();
      this.moved = false;
    }
  }

  onPointerDown(event) {
    // Buttons and native touch scrolling keep their own behavior.
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    this.dragging = true;
    this.moved = false;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScroll = this.track.scrollLeft;
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerUp);
  }

  onPointerMove = (event) => {
    if (!this.dragging) return;
    const dx = event.clientX - this.startX;
    if (Math.abs(dx) > 5) {
      this.moved = true;
      // Capture only once a real drag is confirmed: capturing on pointerdown would
      // re-target the later click to the track and break navigation on the cards.
      if (!this.captured) {
        this.captured = true;
        this.track.setPointerCapture(this.pointerId);
      }
      this.track.classList.add('scentiva-collection-rail--dragging');
    }
    this.track.scrollLeft = this.startScroll - dx;
  };

  onPointerUp = () => {
    this.dragging = false;
    this.captured = false;
    this.track.classList.remove('scentiva-collection-rail--dragging');
    this.track.removeEventListener('pointermove', this.onPointerMove);
    this.track.removeEventListener('pointerup', this.onPointerUp);
    this.track.removeEventListener('pointercancel', this.onPointerUp);
  };

  scrollByCard(direction) {
    this.track.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
  }
}

document.querySelectorAll('.scentiva-collection-rail').forEach((rail) => {
  const controller = new ScentivaRail(rail);
  const prev = rail.querySelector('[data-rail-prev]');
  const next = rail.querySelector('[data-rail-next]');
  prev?.addEventListener('click', () => controller.scrollByCard(-1));
  next?.addEventListener('click', () => controller.scrollByCard(1));
});
